'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    var numStr = n.toString();
    return numStr.includes('.') ? numStr.split('.')[1].length : 0;
};